// InfiniteScroll.jsx
import React, { useState, useEffect, useRef } from "react";
import "../css/InfiniteScroll.css"; // reuse your loader styles

const InfiniteScroll = () => {
    const [quotes, setQuotes] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const loaderRef = useRef(null);
    const limit = 10;
    let total = 0;

    // Fetch quotes (replace with your API endpoint)
    const fetchQuotes = async (pageNum) => {
        const API_URL = `https://api.javascripttutorial.net/v1/quotes/?page=${page}&limit=${limit}`;
        setLoading(true);
        try {
            let response = await fetch(API_URL);
            if (response.ok) {
                let result = await response.json();
                total = result.total;
                setQuotes((prev) => [...prev, ...result.data]);
            }
        } catch (err) {
            console.error("Error fetching quotes:", err);
        } finally {
            setLoading(false);
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                setPage((prev) => prev + 1);
            }
        },
        { threshold: 1 }
    );

    useEffect(() => {
        fetchQuotes(page);
    }, [page]);

    // Infinite scroll using IntersectionObserver
    useEffect(() => {
        if (loaderRef.current && !loading) {
            observer.observe(loaderRef.current);
        }
        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, []);

    return (
        <div className="infinite-scroll">
            <h2>Programming Quotes</h2>
            <div className="scrollable quotes">
                {quotes.map((q, idx) => (
                    <blockquote key={idx} className="quote">
                        <span>[{q.id}] </span> {q.quote} <footer>-- {q.author}</footer>
                    </blockquote>
                ))}
                {/* Conditional rendering */}
                <div className="loader" ref={loaderRef}>
                    <div /><div /><div />
                </div>
            </div>
        </div>
    );
};

export default InfiniteScroll;
